import type { Component, Entity2D } from '../../../odie';
import { GrassBlockProps } from './GrassBlock';
import { GrassBlockView } from './GrassBlockView';

export type GrassBlockComponentOptions = {
  props: GrassBlockProps;
  option?: number;
};

export class GrassBlockComponent implements Component {
  public static readonly NAME = 'blockGrass';
  public entity!: Entity2D;
  public view!: GrassBlockView;
  private props!: GrassBlockProps;

  public init(options: GrassBlockComponentOptions): void {
    const optionDef = options.props.options[options.option ?? 0];

    this.props = options.props;
    this.view = new GrassBlockView(options.props, optionDef.count);
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public hit(): boolean {
    const count = this.view.count - 1;
    if (count <= 0) return true;

    this.view.count = count;
    return false;
  }

  public getGameplayState(): number {
    return this.props.options.findIndex(
      (option) => option.count === this.view.count,
    );
  }
}
